import _ from 'lodash'
import {
    isIOS
} from './ua'
const setTitle = title => {
    // 判断是IOS还是安卓进行设置title
    if (isIOS) {
        setTimeout(() => {
            document.title = title
            var iframe = document.createElement('iframe')
            iframe.style.visibility = 'hidden'
            iframe.style.width = '1px'
            iframe.style.height = '1px'
            iframe.onload = function () {
                setTimeout(function () {
                    document.body.removeChild(iframe)
                }, 0)
            }
            document.body.appendChild(iframe)
        }, 0)
    } else {
        document.title = title
    }
}

/**
 * 百度坐标 转换为 腾讯坐标
 *
 * @param {number} lat 纬度
 * @param {number} lng 经度
 * @returns
 */
function transMapBd2Tx (lat, lng) {
    // 百度转gcj02(腾讯, 高德)
    let tx_lat, tx_lng
    const x = lng - 0.0065
    const y = lat - 0.006
    const x_pi = (3.14159265358979324 * 3000.0) / 180.0
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)

    tx_lat = z * Math.sin(theta)
    tx_lng = z * Math.cos(theta)

    return {
        tx_lat,
        tx_lng
    }
}

/**
 * gcj02转百度(腾讯, 高德)
 * @param {经度} lng
 * @param {纬度} lat
 */
function transMapTx2Bd (lng, lat) {
    if (lng == null || lng === '' || lat == null || lat === '') { return [lng, lat] }
    var x_pi = 3.14159265358979324
    var x = parseFloat(lng)
    var y = parseFloat(lat)
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
    var longitude = (z * Math.cos(theta) + 0.0065).toFixed(5)
    var latitude = (z * Math.sin(theta) + 0.006).toFixed(5)
    return {
        lng: longitude,
        lat: latitude
    }
}

const formateUrl = url => {
    //     // 微信code返回&code=09002xdd
    //     // http://192.168.3.115:8080/#/activity_index 链接不带?,不带参数，需添加?
    //     // http://192.168.3.115:8080/?from=singlemessage#/activity_index 去掉?from
    let URL = url || location.href
    const hasQuery = URL.split('#')[1]
    hasQuery.indexOf('?') < 0 && (URL += '?')
    URL = URL.replace(/\?.{0,}#/, '#')
    // 支付路径绑定到hash之前
    URL = URL.replace(/#/, '?#')
    URL = encodeURIComponent(URL)
    return URL
}

function getQueryString (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return unescape(r[2])
    };
    return null
}

function checkStorage () {
    let storage = (window && window.localStorage)
    if (storage) {
        try {
            storage.setItem('storageTest', 'value')
            if (storage.getItem('storageTest') !== 'value') {
                storage.removeItem('storageTest')
                throw '您的浏览器处于无痕模式,请退出无痕模式后再重新打开本页面' // eslint-disable-line
            }
            storage.removeItem('storageTest')
            return {
                valid: true
            }
        } catch (e) {
            return {
                valid: false,
                msg: e
            }
        }
    } else {
        return {
            valid: false,
            msg: '您的浏览器不支持本地存储'
        }
    }
}

const qualityImgUrl = (url, config) => {
    if (!_.isString(url)) {
        throw new Error('url must be string')
    }
    const {width, height, contrast = 'q', percentage = 100} = config
    if (!width || !height) {
        throw new Error('width and height must both specify')
    }
    // 如果percentage大于100，默认100，小于0，默认0
    let per = percentage
    if (Number(percentage) > 100) {
        per = 100
    } else if (Number(percentage) < 0) {
        per = 0
    }
    // 处理内测环境的非标准 url 转成普通 url
    const imgType = url.split('.').pop()
    if (!imgType.match(/jpg|webp/g)) {
        return url
    }
    // ?x-oss-process=image/resize,w_100,h_100/quality,q_100;
    const targetSizeStr = `?x-oss-process=image/resize,w_${width},h_${height}/quality,${contrast}_${per}`

    return url + targetSizeStr
}
const toQueryObject = (obj) => {
    let str = ''
    for (let key in obj) {
        str += `${key}=${obj[key]}&`
    }
    return str
}

function queryKey (queryParams, keys) {
    let isHas = true
    keys.forEach(key => {
        if (!queryParams[key]) {
            isHas = false
        }
    })
    return isHas
}

function stringToObject (params) {
    const arr = params.split('&')
    const obj = {}
    arr.forEach(item => {
        const o = item.split('=')
        obj[o[0]] = obj[[o][1]]
    })
    return obj
}

export {
    transMapBd2Tx,
    transMapTx2Bd,
    setTitle,
    formateUrl,
    getQueryString,
    checkStorage,
    qualityImgUrl,
    toQueryObject,
    queryKey,
    stringToObject
}
